import { default as ProductCardImage } from './product-card-image'

export default ProductCardImage
